export default __webpack_public_path__ + "static/media/login-v2.2198399d.svg";